import { useSession } from "@/entities/session";
import { routePaths } from "@/shared/config/routePaths";
import { Navigate, useLocation } from "react-router-dom";

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
    const { isAuthenticated } = useSession();
    const location = useLocation()

    if (!isAuthenticated) {
        return (
            <Navigate
                to={routePaths.auth}
                state={{ from: location.pathname }}
                replace />
        )
    }

    return <>{children}</>;
};